import React from "react";
import { number, string } from "prop-types";

const SaveIcon = ({ color = "#999999", width = 24, height = 32 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 32">
    <defs />
    <path fill={color} d="M0 32V3a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v29l-12-7z" />
  </svg>
);

SaveIcon.propTypes = {
  width: number,
  height: number,
  color: string
};

export default SaveIcon;
